import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateToString',
})
export class DateToStringPipe implements PipeTransform {
  transform(value: Date | undefined): string {
    if (value) {
      return (
        (value.getDate() < 10 ? '0' + value.getDate() : value.getDate()) +
        '/' +
        (value.getMonth() + 1 < 10
          ? '0' + (value.getMonth() + 1)
          : value.getMonth() + 1) +
        '/' +
        value.getFullYear() +
        ' à ' +
        value.toTimeString()
      );
    }
    return 'Date inconnue';
  }
}
